var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZone3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3840 2061",
    style: {
      enableBackground: "new 0 0 3840 2061"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "zone_3_path"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#E961B1",
      strokeWidth: 41.9615,
      strokeMiterlimit: 10
    },
    d: "M1205.09,1671.188 c3.057,20.168,8.614,39.839,16.61,58.744c12.421,29.366,30.189,55.727,52.812,78.35c22.624,22.624,48.985,40.393,78.351,52.813 c30.437,12.874,62.733,19.402,95.989,19.402h124.496c58.425-0.053,161.837-0.08,307.387-0.08 c118.668,0,262.192,0.018,426.586,0.052c0.002,0,0.038,0,0.04,0c47.427,0,91.821-18.661,125.004-52.545 c17.359-17.725,30.659-38.721,39.145-61.606l470.73,2.195c0.208,0.001,0.431,0.001,0.657,0.001 c36.717-0.001,71.271-14.269,97.299-40.176c10.429-10.381,18.964-22.034,25.509-34.804l370.434,0.159h0.108 c65.616,0,127.487-25.37,174.214-71.438c46.756-46.095,73.005-107.637,73.911-173.289l0.945-68.427"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZone3);
export default __webpack_public_path__ + "static/media/zone_3.94c71802.svg";
export { ForwardRef as ReactComponent };